
import $ from "jquery"
import log from "plugins/loglevel/index"
import {EventEmitter} from "events"

export interface Selector {
  scope:  string | Element | JQuery
  main:   string | Element | JQuery

  min_select: string | Element | JQuery
  max_select: string | Element | JQuery
}
export interface InputSelector {
  scope?:  string | Element | JQuery
  main?:   string | Element | JQuery

  min_select?: string | Element | JQuery
  max_select?: string | Element | JQuery
}
const DEFAULT_SELECTOR = {
  scope:  ".cell-listing-filter",
  main:   "#filter-option-price-container",

  min_select: ".filter-option-min",
  max_select: ".filter-option-max",
}


interface Options {
  run_post_initialization: boolean
}
interface InputOptions {
  run_post_initialization?: boolean
}
const DefaultOptions = {
  run_post_initialization: true,
}


class MinMaxSelect extends EventEmitter {
  protected selector: Selector

  protected $scope: JQuery
  protected $el: JQuery

  protected $min_select: JQuery
  protected $max_select: JQuery

  constructor(selector?: InputSelector, options?: InputOptions) {
    const opts: Options = Object.assign({}, DefaultOptions, options)
    super()

    this.selector = Object.assign({}, DEFAULT_SELECTOR, selector)
    this.$scope = $(this.selector.scope)

    this.$el = this.$scope.find(this.selector.main)

    this.$min_select = this.$el.find(this.selector.min_select)
    this.$max_select = this.$el.find(this.selector.max_select)

    this.renewMaxOptions()

    if (this.$el.length === 0){
      log.error(`scope: ${this.selector.scope}, main: ${this.selector.main}`)
      throw new Error("two select init with null element")
    }

    if (opts.run_post_initialization) {
      this.bind_action()
    }
  }

  public reset(){
    this.$min_select.val("")
    this.$max_select.val("")
    this.renewMaxOptions()
  }
  public isDefault(){
    return [this.$max_select, this.$min_select].every(($el) => {
      const selected = $el.find("option:selected")
      const first = $el.find("option:first")
      return selected.length === 1 && selected.is(first)
    })
  }
  public count(){
    return [this.$max_select, this.$min_select].reduce((memo, $el) => {
      const selected = $el.find("option:selected")
      const first = $el.find("option:first")
      if (selected.length === 1 && selected.is(first)){
        return memo
      }

      return memo + 1
    }, 0)
  }

  protected bind_action(): void{
    this.$el.on("change", (e) => {
      this.onChange(e)
    })
  }
  protected onChange(e: Event){
    const target = e.target
    const min_value = parseInt(this.$min_select.val(), 10) || null
    const max_value = parseInt(this.$max_select.val(), 10) || null

    if ( min_value !== null && max_value !== null && (min_value > max_value)){
      this.updateMinGtMax()
    }
    if (this.$min_select.is(target)){
      this.renewMaxOptions()
    }
  }
  protected updateMinGtMax(){
    const min_value = parseInt(this.$min_select.val(), 10)
    this.$max_select.val(min_value)
  }
  protected renewMaxOptions(){
    const min_value = parseInt(this.$min_select.val(), 10) || null

    // do nothing as min_value is set to `Minimum`
    if (min_value === null){
      // make all option available
      this.$max_select.find("option").prop("disabled", false)
      return
    }

    this.$max_select.find("option").toArray().forEach((el) => {
      const val = parseInt((el as HTMLOptionElement).value, 10) || null
      if (val !== null){
        if (val < min_value){
          el.setAttribute("disabled", "disabled")
        }
        else{
          el.removeAttribute("disabled")
        }
      }
    })
  }
}


const Factory = {
  create(selector?: InputSelector){
    return new MinMaxSelect(selector)
  },
}


export {
  Factory as default,
  MinMaxSelect,
  DEFAULT_SELECTOR,
}
